import React, { useState } from "react";
import RequestService from "../../../services/request.service";

// // import { Modal, Row, Form, Button, Col, InputGroup } from 'react-bootstrap'
import { Button, Modal, ToggleButton, ButtonGroup } from 'react-bootstrap'

// // import { Formik } from 'formik';
// // import * as yup from 'yup';


import { toast } from 'react-toastify'

// import { confirm } from '../../widgets/confirm'

// // // // import './solicitudes.scss';

import './reporte_mensual.scss';

// import DatePicker, { registerLocale } from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import es from 'date-fns/locale/es';

import moment from 'moment'
import 'moment/locale/es';



// import { SERVER_ } from  '../../config';


import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Ticks,
  ArcElement
} from 'chart.js';

// import { getRelativePosition } from 'chart.js/helpers';


import { Bar, Doughnut } from 'react-chartjs-2';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

// const ChartD = require('react-chartjs-2').Chart;

// const originalDoughnutDraw = Doughnut.prototype.draw;
// ChartD.helpers.extend(Doughnut.prototype, {
//     draw() {
//           originalDoughnutDraw.apply(this, arguments);
          
//           var chart = this.chart;
//           var width = chart.chart.width,
//               height = chart.chart.height,
//               ctx = chart.chart.ctx;

//           var fontSize = (height / 114).toFixed(2);
//           ctx.font = fontSize + "em sans-serif";
//           ctx.textBaseline = "middle";

//           var sum = 0;
//           for (var i = 0; i < chart.config.data.datasets[0].data.length; i++) {
//             sum += chart.config.data.datasets[0].data[i];
//           }

//           var text = sum,
//               textX = Math.round((width - ctx.measureText(text).width) / 2),
//               textY = height / 2;

//           ctx.fillText(text, textX, textY);
//     }
// });

  // ChartJS.pluginService.register({
  //   beforeDraw: function (chart) {
  //     var width = chart.chart.width,
  //       height = chart.chart.height,
  //       ctx = chart.chart.ctx;
  //     ctx.font = 2 + "em sans-serif";
  //     ctx.textBaseline = "bottom";
  //     ctx.fillStyle = "red";
  //     ctx.fillText("Text Here", width / 2 - 60, height / 2 + 100);
  //     ctx.save();
  //   }
  // });


const ReporteMensual = ( props ) =>{

const labels = [""];

const [checked, setChecked] = useState(false);

const options = {
    scales: {
        x: {
            ticks: {
                // Include a dollar sign in the ticks
                callback: function(value, index, ticks) {
                    return '$' + Ticks.formatters.numeric.apply(this, [value, index, ticks]);
                },
                color: (checked ?  'white' : 'black')
            },
            grid: {
              color: (checked ?  'white' : '#f2f2f2'),
              // borderColor: '#2b8f90',
              // lineWidth : 3
            }
        },
        y: {
            ticks: {
                color: (checked ?  'white' : 'black')
            },
            grid: {
              color: (checked ?  'white' : '#f2f2f2'),
              // borderColor: '#2b8f90',
              // lineWidth : 3
            }
        }
    },
    indexAxis: 'y' as const,
    elements: {
        bar: {
            borderWidth: 2,
        },
    },
    responsive: true,
    plugins: {
        legend: {
            display: false
        },
        title: {
            display: true,
            text: 'Saldo SF por Día',
        },
    },


};

const [data, setDataChart ] = useState<any>({
                                      labels,
                                      datasets: [
                                        {
                                          label: 'Monto',
                                          data: [0],
                                          borderColor: 'rgb(53, 162, 235)',
                                          backgroundColor: 'rgba(53, 162, 235, 0.5)',
                                        },
                                      ],
                                    });

  const { fecha_reporte, showModalReporteMensual , handleClose, uuid_sucursal } = props


  // React.useEffect(() => {
  //   // cargarSucursales()
  //   cargarReporte()
  // }, []);


  const [ reporteData, setReporteDate ] = useState<any>({
    total : 0,
    total_folios_mes : 0,
    reporteData : {
      etiquetas : [""]
    },
    reporte_por_semanas : []
  })

  const cargarReporte = async (date:string) =>{
    try{
      // console.log(fecha_reporte)
      let response = await RequestService.getEndPoint('modal/reporte_mensual/'+uuid_sucursal+'/'+date)
      setReporteDate(response.data)
      // console.log(eti)
      setDataChart({
          labels : response.data.reporteData.etiquetas,
          datasets: [
            {
              label: 'Monto',
              data: response.data.reporteData.data,
              borderColor: '#247879',
              backgroundColor: '#36b3b4',
            },
          ],
        })



    }
    catch(e){
      // console.log(e)
      toast.error('Error al cargar el reporte')
    }
  }


const currencyFormat = (num) => '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')



const dona = {
  labels: ['Red', 'Blue'],
  datasets: [
    {
      label: '# of Votes',
      data: [80,20],
      backgroundColor: [
        '#247879',
        'rgba(255,255,255,0)',
      ],
      borderColor: [
        '#36b3b4',
        '#247879',
      ],
      borderWidth: 1,
    },
  ],
};
    const options_ = {
      responsive: false,
      maintainAspectRatio: false,

        rotation: -90,
        circumference: 180,

  plugins: {
   legend: {
    display: false
   },
    title: {
      display: true,
      text: 'Meta del Mes',
    },
  },
    }







      return (



          <>


              <Modal
                size="lg"
                onEnter={()=>{cargarReporte(fecha_reporte)}}
                show={showModalReporteMensual}
                backdrop="static"
              >
                <Modal.Header style={{'background': (checked ?  '#283878' : 'white')}}>
                  <Modal.Title>
                    <h4 style={{color : (checked ?  'white' : 'black') }}>REPORTE DEL MES DE {moment(fecha_reporte).format('MMMM').toUpperCase()} DEL 2001</h4>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{
                                  background: (checked ?  '#1e2e6b' : 'white'), 
                                  backgroundImage: (checked ?  'url("../assets/clean-textile.png")' : 'none'), 
                                  color : (checked ?  'white' : 'black') 
                                }}>


                  <div className="row">
                    <div className="col-7">

                        <div className="row">
                          <div className="col-4">
                                <small>Total de Folios</small>
                                <h2>{reporteData.total_folios_mes}</h2>
                          </div>
                          <div className="col-8">
                                <small>Montos Totales</small>
                                <h2>{currencyFormat(reporteData.total)}</h2>
                          </div>
                        </div>


                          <Doughnut className="mb-4 mt-2" data={dona} width="450px" height="140px" options={options_}  />


                          <Bar options={options} data={data} width="100%" height={200} />

                    </div>

                    <div className="col-5">
                        {
                          // JSON.stringify(reporteData.reporte_por_semanas)
                        }

                        <table className="table table-striped table-sm" >
                          <tbody>

                            {

                              reporteData.reporte_por_semanas.map( (semana:any, i:number) =>

                                  <React.Fragment key={i}>

                                    <tr >
                                      <td>
                                        <small style={{color : (checked ?  'white' : 'black')}}>{semana.semana}</small>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        


                                            <table className="table table-sm" style={{color : (checked ?  'white' : 'black')}}>
                                              <thead>
                                                <tr>
                                                  <th scope="col">Día</th>
                                                  <th scope="col">Folios</th>
                                                  <th scope="col">Monto</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                              {
                                                semana.dias.map( dia =>

                                                      <tr key={dia.dia}>
                                                        <th scope="row" className="text-right chiquitos">
                                                          <small>{dia.dia}</small>
                                                        </th>
                                                        <td className="text-center chiquitos">
                                                          <small>{(dia.cantidad)}</small>
                                                        </td>
                                                        <td className="text-right chiquitos">
                                                          <small>{currencyFormat(dia.monto)}</small>
                                                        </td>
                                                      </tr>

                                                  )
                                              }

                                                      <tr>
                                                        <th scope="row" className="text-right chiquitos">
                                                          <small><b>TOTAL</b></small>
                                                        </th>
                                                        <td className="text-center chiquitos">
                                                          <small>{(semana.total_folios)}</small>
                                                        </td>
                                                        <td className="text-right chiquitos">
                                                          <small>{currencyFormat(semana.monto_total)}</small>
                                                        </td>
                                                      </tr>


                                              </tbody>
                                            </table>



                                      </td>
                                    </tr>

                                  </React.Fragment>

                                )

                            }


                          </tbody>
                        </table>


                    </div>
                  </div>



                      

                </Modal.Body>
                <Modal.Footer style={{'background': (checked ?  '#283878' : 'white')}}>
{

                    // <ButtonGroup>
                    //   <ToggleButton
                    //     id="toggle-check"
                    //     type="checkbox"
                    //     variant="primary"
                    //     checked={checked}
                    //     value="1"
                    //     onChange={(e) => setChecked(e.currentTarget.checked)}
                    //   >
                    //     { !checked ? 'TEMA DÍA'  : 'TEMA NOCTURNO NEON'}
                    //   </ToggleButton>
                    // </ButtonGroup>
}


                  <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                  </Button>
                </Modal.Footer>
              </Modal>




              
          </>

      );
  

}

export default ReporteMensual